export default __webpack_public_path__ + "static/media/plot.66327b7f.png";